module.exports = __webpack_public_path__ + "img/logo_login.13e07352.png";